import React, { PropsWithChildren } from "react";

const EmptyLayout: React.FC = (props: PropsWithChildren) => {
  const { children } = props;
  return <React.Fragment>{children}</React.Fragment>;
};

EmptyLayout.displayName = "EmptyLayout";
export default EmptyLayout;
